import { createFileRoute } from '@tanstack/react-router';
import { AdminGuard } from '@/components/admin-guard';
import { AdminSubNav } from '@/components/shell/AdminSubNav';
import { ReleaseNotesAdminListView } from '@/features/release-notes/admin/ReleaseNotesAdminListView';

export const Route = createFileRoute('/admin/release-notes/')({
  component: () => (
    <AdminGuard>
      <AdminSubNav />
      <div className="container mx-auto max-w-4xl p-6">
        <ReleaseNotesAdminListView />
      </div>
    </AdminGuard>
  )
});
